module.exports = __webpack_public_path__ + "img/iotag.788ad881.png";